import { REGEX } from 'src/constants';
import { isEmailNotContainsPhoneNumber } from 'src/utilities/string';
import * as yup from 'yup';

export const formSchema = yup
  .object({
    brand_name: yup
      .string()
      .label('common_brandName')
      .required()
      .max(64)
      .matches(
        REGEX.ALPHANUMERIC_WITH_SPACES,
        '${label} cannot use special characters',
      )
      .notOneOf(['tokoku', 'pulsamarket', 'galaxyyshop101']),
    full_name: yup.string().max(64).required().label('common_fullName'),
    username: yup
      .string()
      .matches(REGEX.NAME, 'form_errorMessage_string_alphanumeric|path:${path}')
      .min(6)
      .max(64)
      .required()
      .label('common_username'),
    email: yup
      .string()
      .email()
      .test(
        'is-email',
        'formError_wrongEmailFormat',
        isEmailNotContainsPhoneNumber,
      )
      .required()
      .label('common_email'),
    country_code: yup.string().required(),
    phone_number: yup
      .string()
      .matches(/^[0-9]+$/, {
        excludeEmptyString: true,
        message: 'form_errorMessage_string_numbersOnly|path:${path}',
      })
      .label('common_phoneNumber')
      .required(),
  })
  .required();

export type RegisterChildFormType = yup.InferType<typeof formSchema>;
